// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Audit filter bar — aligned to Haven brand tokens (see shared/brand-variables.css).
   Also renders inside the admin-shell's dark scope (.admin-layout), which
   overrides the same --color-* tokens; no hard-coded fallbacks needed. */
.audit-filter-bar {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: var(--color-surface-light);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  margin-bottom: 16px;
}

.audit-filter-bar-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.audit-filter-bar-row--controls {
  gap: 8px;
}

.audit-filter-search {
  position: relative;
  flex: 1 1 320px;
  min-width: 240px;
}

.audit-filter-search-input {
  width: 100%;
  padding: 6px 32px 6px 10px;
  background: var(--color-surface-light);
  color: var(--color-text-primary);
  border: 1px solid var(--color-surface-dark);
  border-radius: 6px;
  font-size: 13px;
  outline: none;
  box-sizing: border-box;
}

.audit-filter-search-input:focus {
  border-color: var(--color-secondary);
  box-shadow: 0 0 0 2px rgba(76, 106, 88, 0.15);
}

.audit-filter-search-clear {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
}

.audit-filter-search-clear:hover {
  color: var(--color-text-primary);
}

.audit-filter-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 140px;
}

.audit-filter-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-text-secondary);
  font-weight: 600;
}

.audit-filter-field select,
.audit-filter-field input[type="date"] {
  padding: 6px 10px;
  background: var(--color-surface-light);
  color: var(--color-text-primary);
  border: 1px solid var(--color-surface-dark);
  border-radius: 6px;
  font-size: 13px;
  min-width: 140px;
  outline: none;
}

.audit-filter-field select:focus,
.audit-filter-field input[type="date"]:focus {
  border-color: var(--color-secondary);
  box-shadow: 0 0 0 2px rgba(76, 106, 88, 0.15);
}

.audit-filter-field select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.audit-filter-count {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin-left: auto;
}

.audit-filter-clear-all {
  align-self: flex-end;
  padding: 6px 12px;
  background: transparent;
  color: var(--color-text-secondary);
  border: 1px solid var(--color-surface-dark);
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  transition: color 0.15s, border-color 0.15s;
}

.audit-filter-clear-all:hover {
  color: var(--color-secondary);
  border-color: var(--color-secondary);
}

/* -----------------------------------------------------------------
   Mobile: stack filter controls into a two-column grid below 640px.

   Above 640px the flex-wrap layout leaves the dropdowns hugging their
   content, which can look scattered on a narrow screen. This forces a
   consistent 2-across grid so the whole bar reads as one form. Search
   input spans both columns to keep enough room to type.
   ----------------------------------------------------------------- */
@media (max-width: 640px) {
  .audit-filter-bar-row {
    gap: 8px;
  }

  .audit-filter-search {
    flex: 1 1 100%;
    min-width: 0;
  }

  .audit-filter-count {
    margin-left: 0;
    font-size: 12px;
  }

  .audit-filter-bar-row--controls {
    display: grid;
    /* auto-fit + minmax(160px, 1fr) means: fit as many columns as
       possible where each is at least 160px wide, otherwise reduce
       the column count. On iPhone SE (320px viewport minus padding
       ≈ 280px available) that means a single column so the From/To
       date inputs stop pushing past the panel. On typical phones
       (390-430px) it stays 2 columns as before. */
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 8px;
  }

  .audit-filter-field {
    min-width: 0;
    width: 100%;
  }

  .audit-filter-field select,
  .audit-filter-field input[type="date"] {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    /* WebKit's native <input type="date"> has an intrinsic width that
       includes the calendar-picker button, and without an explicit
       max-width it can exceed its grid cell on narrow screens. */
  }

  /* Clear-filters button gets its own row spanning both columns so it
     always looks intentional rather than tacked on to whichever cell
     ended up last. */
  .audit-filter-clear-all {
    grid-column: 1 / -1;
    justify-self: end;
    min-height: var(--touch-target-min, 44px);
  }
}

/* Belt-and-braces: even below 640px, some content had been extending
   past the .audit-filter-bar's border because border-box wasn't set on
   the wrapper. This guarantees the bar can't spill its parent. */
@media (max-width: 767px) {
  .audit-filter-bar {
    padding: 12px;
    max-width: 100%;
    box-sizing: border-box;
    overflow: hidden;
  }

  .audit-filter-bar-row,
  .audit-filter-bar-row--controls {
    max-width: 100%;
    box-sizing: border-box;
  }

  /* Search input can push wider than its parent when a placeholder is
     long; explicit box-sizing + min-width: 0 + max-width guarantees the
     input never contributes to horizontal overflow. */
  .audit-filter-search {
    max-width: 100%;
    box-sizing: border-box;
  }

  .audit-filter-search-input {
    max-width: 100%;
    box-sizing: border-box;
  }
}
`, "",{"version":3,"sources":["webpack://./../shared/audit/AuditFilterBar.css"],"names":[],"mappings":"AAAA;;yEAEyE;AACzE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,sCAAsC;EACtC,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,sCAAsC;EACtC,gCAAgC;EAChC,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,sCAAsC;EACtC,gCAAgC;EAChC,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,kCAAkC;EAClC,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;;;;;;;sEAOsE;AACtE;EACE;IACE,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb;;;;;kDAK8C;IAC9C,2DAA2D;IAC3D,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;IACf;;iEAE6D;EAC/D;;EAEA;;qBAEmB;EACnB;IACE,mBAAmB;IACnB,iBAAiB;IACjB,yCAAyC;EAC3C;AACF;;AAEA;;iEAEiE;AACjE;EACE;IACE,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,sBAAsB;EACxB;;EAEA;;sDAEoD;EACpD;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;AACF","sourcesContent":["/* Audit filter bar — aligned to Haven brand tokens (see shared/brand-variables.css).\n   Also renders inside the admin-shell's dark scope (.admin-layout), which\n   overrides the same --color-* tokens; no hard-coded fallbacks needed. */\n.audit-filter-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  background: var(--color-surface-light);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  margin-bottom: 16px;\n}\n\n.audit-filter-bar-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.audit-filter-bar-row--controls {\n  gap: 8px;\n}\n\n.audit-filter-search {\n  position: relative;\n  flex: 1 1 320px;\n  min-width: 240px;\n}\n\n.audit-filter-search-input {\n  width: 100%;\n  padding: 6px 32px 6px 10px;\n  background: var(--color-surface-light);\n  color: var(--color-text-primary);\n  border: 1px solid var(--color-surface-dark);\n  border-radius: 6px;\n  font-size: 13px;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.audit-filter-search-input:focus {\n  border-color: var(--color-secondary);\n  box-shadow: 0 0 0 2px rgba(76, 106, 88, 0.15);\n}\n\n.audit-filter-search-clear {\n  position: absolute;\n  right: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.audit-filter-search-clear:hover {\n  color: var(--color-text-primary);\n}\n\n.audit-filter-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 140px;\n}\n\n.audit-filter-label {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--color-text-secondary);\n  font-weight: 600;\n}\n\n.audit-filter-field select,\n.audit-filter-field input[type=\"date\"] {\n  padding: 6px 10px;\n  background: var(--color-surface-light);\n  color: var(--color-text-primary);\n  border: 1px solid var(--color-surface-dark);\n  border-radius: 6px;\n  font-size: 13px;\n  min-width: 140px;\n  outline: none;\n}\n\n.audit-filter-field select:focus,\n.audit-filter-field input[type=\"date\"]:focus {\n  border-color: var(--color-secondary);\n  box-shadow: 0 0 0 2px rgba(76, 106, 88, 0.15);\n}\n\n.audit-filter-field select:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.audit-filter-count {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  margin-left: auto;\n}\n\n.audit-filter-clear-all {\n  align-self: flex-end;\n  padding: 6px 12px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  border: 1px solid var(--color-surface-dark);\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: color 0.15s, border-color 0.15s;\n}\n\n.audit-filter-clear-all:hover {\n  color: var(--color-secondary);\n  border-color: var(--color-secondary);\n}\n\n/* -----------------------------------------------------------------\n   Mobile: stack filter controls into a two-column grid below 640px.\n\n   Above 640px the flex-wrap layout leaves the dropdowns hugging their\n   content, which can look scattered on a narrow screen. This forces a\n   consistent 2-across grid so the whole bar reads as one form. Search\n   input spans both columns to keep enough room to type.\n   ----------------------------------------------------------------- */\n@media (max-width: 640px) {\n  .audit-filter-bar-row {\n    gap: 8px;\n  }\n\n  .audit-filter-search {\n    flex: 1 1 100%;\n    min-width: 0;\n  }\n\n  .audit-filter-count {\n    margin-left: 0;\n    font-size: 12px;\n  }\n\n  .audit-filter-bar-row--controls {\n    display: grid;\n    /* auto-fit + minmax(160px, 1fr) means: fit as many columns as\n       possible where each is at least 160px wide, otherwise reduce\n       the column count. On iPhone SE (320px viewport minus padding\n       ≈ 280px available) that means a single column so the From/To\n       date inputs stop pushing past the panel. On typical phones\n       (390-430px) it stays 2 columns as before. */\n    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n    gap: 8px;\n  }\n\n  .audit-filter-field {\n    min-width: 0;\n    width: 100%;\n  }\n\n  .audit-filter-field select,\n  .audit-filter-field input[type=\"date\"] {\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n    /* WebKit's native <input type=\"date\"> has an intrinsic width that\n       includes the calendar-picker button, and without an explicit\n       max-width it can exceed its grid cell on narrow screens. */\n  }\n\n  /* Clear-filters button gets its own row spanning both columns so it\n     always looks intentional rather than tacked on to whichever cell\n     ended up last. */\n  .audit-filter-clear-all {\n    grid-column: 1 / -1;\n    justify-self: end;\n    min-height: var(--touch-target-min, 44px);\n  }\n}\n\n/* Belt-and-braces: even below 640px, some content had been extending\n   past the .audit-filter-bar's border because border-box wasn't set on\n   the wrapper. This guarantees the bar can't spill its parent. */\n@media (max-width: 767px) {\n  .audit-filter-bar {\n    padding: 12px;\n    max-width: 100%;\n    box-sizing: border-box;\n    overflow: hidden;\n  }\n\n  .audit-filter-bar-row,\n  .audit-filter-bar-row--controls {\n    max-width: 100%;\n    box-sizing: border-box;\n  }\n\n  /* Search input can push wider than its parent when a placeholder is\n     long; explicit box-sizing + min-width: 0 + max-width guarantees the\n     input never contributes to horizontal overflow. */\n  .audit-filter-search {\n    max-width: 100%;\n    box-sizing: border-box;\n  }\n\n  .audit-filter-search-input {\n    max-width: 100%;\n    box-sizing: border-box;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
